import pageImage from '../../assets/images/page-banner-img.png'

function ContactSection() {
    return (
        <>
            <div className="page-banner-area pt-100">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="single-page-banner-content">
                                <h1>Contact Us</h1>
                                <ul>
                                    <li>
                                        <a href="/">Home</a>
                                    </li>
                                    <li>
                                        Contact Us
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="single-page-banner-img" >
                                <img src={pageImage} alt="images" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="contact-area pt-100 pb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5" >
                            <div className="single-contact-card">
                                <div className="contact-box">
                                    <i className="flaticon-pin"></i>
                                    <h3>Office Address</h3>
                                    <p>Lahore, Pakistan</p>
                                </div>
                                <div className="contact-box">
                                    <i className="flaticon-phone-call"></i>
                                    <h3>Get in Touch</h3>
                                    <span>Telephone:<a href="tel:+923061922327">+923061922327</a></span>
                                    <span className="mail">Email:<a href="mailto:usama@thejunestore.com"><span className="__cf_email__" >usama@thejunestore.com</span></a></span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7" >
                            <div className="contact-form-content">
                                <div className="section-title section-title-left">
                                    <span className="top-title">Contact Us</span>
                                    <h2>Request A Quote</h2>
                                </div>
                                <form id="contactForm" onSubmit={(e)=>e.preventDefault()}>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-6">
                                            <div className="form-group">
                                                <input type="text" name="name" id="name" className="form-control" placeholder="Name" required />
                                            </div>
                                        </div>

                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <input type="email" name="email" id="email" placeholder="Email" required className="form-control" />
                                            </div>
                                        </div>

                                        <div className="col-lg-6 col-md-12">
                                            <div className="form-group">
                                                <input type="number" name="phone_number" id="phone_number" className="form-control" placeholder="Phone" required  />
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <textarea name="message" className="form-control" id="message" cols="5" rows="7" placeholder="Message" required ></textarea>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <div className="form-check">
                                                    <input
                                                        name="gridCheck"
                                                        value="I agree to the terms and privacy policy."
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="gridCheck"
                                                        required
                                                    />
                                                    <label className="form-check-label" for="gridCheck">
                                                        I Agree To The <a href="terms-conditions.html">Terms & Conditions</a> And <a href="privacy-policy.html">Privacy Policy</a>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-12 col-md-12">
                                            <button type="submit" className="default-btn">
                                                Send Message
                                            </button>
                                            <div id="msgSubmit" className="h3 text-center hidden"></div>
                                            <div className="clearfix"></div>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="google-map-area">
                <div className="container-fluid">
                    <div className="map">
                        <iframe className="maps" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4084411.0093602007!2d30.058401399112643!3d1.3671055328826824!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1771a69f6499f945%3A0x874155ce43014549!2sUganda!5e0!3m2!1sen!2sbd!4v1661595038526!5m2!1sen!2sbd"></iframe>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactSection